<div class="create-ticket"> 
  <div class="create-ticket__header">
    <span class="create-ticket__header__title">Crear ticket</span>
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="create-ticket__body"> 
    <div class="create-ticket__container">
      <div class="create-ticket__info">
        <span>{{order.orderId}}</span>
      </div>
      <div class="create-ticket__options">
        <a mat-button class="create-ticket__options__button" [href]="this.getAriaUrl()" target="_blank">
          <mat-icon svgIcon="ariaIcon">ariaIcon</mat-icon>
          <span>ARIA</span>
        </a>
        <a mat-button class="create-ticket__options__button" [href]="this.getRexUrl()" target="_blank">
          <mat-icon svgIcon="rexIcon">rexIcon</mat-icon>
          <span>REX</span>
        </a>
      </div>
    </div>
  </div>
</div>
